<template>
    <a class="mint-cell mint-field mint-select">
        <div class="mint-cell-left"></div>
        <div class="mint-cell-wrapper">
            <div class="mint-cell-title">
                <span class="mint-cell-text">{{ selectLabel }}</span>
            </div>
            <div class="mint-cell-value">
                <input @click="showChoose" v-model="selectValue" placeholder="点击选择" readonly/>
                <mt-popup
                        v-model="choose"
                        position="bottom"  v-roll:visible=choose>
                    <!--    <div class="picker-confirm-button">确定</div>-->
                    <mt-picker :slots="slots"  @change="onValueChange"></mt-picker>
                </mt-popup>
            </div>
        </div>
        <div class="mint-cell-right"></div>
    </a>
</template>
<script>
    export default{
        data(){
            return {
                choose:false
            }
        },
        props: {
            slots: Array,
            selectLabel: String,
            selectValue:String,
            selectPatch:String
        },

        methods:{
            onValueChange(picker, values) {
                this.$emit('changeValue',[this.selectPatch,values[0]]);
            },
            showChoose(){
                this.choose = true
            }
        }
    }
</script>
<style>
    .mint-popup{
        width:100%;
    }


    .mint-select input{
        width: 100%;
        font-size:16px;
    }

    .mint-select input:focus{
        outline: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/mintSelect.vue